"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var ArrowDirection;
(function (ArrowDirection) {
    ArrowDirection["Left"] = "left";
    ArrowDirection["Right"] = "right";
    ArrowDirection["Up"] = "up";
    ArrowDirection["Down"] = "down";
})(ArrowDirection = exports.ArrowDirection || (exports.ArrowDirection = {}));
var ArrowColor;
(function (ArrowColor) {
    ArrowColor["Default"] = "default";
    ArrowColor["Orange"] = "orange";
})(ArrowColor = exports.ArrowColor || (exports.ArrowColor = {}));
var arrowDirectionProperties = (_a = {},
    _a["left" /* Left */] = {
        path: 'M14.19 16.005l7.869 7.868-2.129 2.129-9.996-9.997L19.937 6.002l2.127 2.129z',
    },
    _a["right" /* Right */] = {
        path: 'M18.629 15.997l-7.083-7.081L13.462 7l8.997 8.997L13.457 25l-1.916-1.916z',
    },
    _a["up" /* Up */] = {
        path: 'M15.997 13.374l-7.081 7.081L7 18.54l8.997-8.998 9.003 9-1.916 1.916z',
    },
    _a["down" /* Down */] = {
        path: 'M16.003 18.626l7.081-7.081L25 13.46l-8.997 8.998-9.003-9 1.917-1.916z',
    },
    _a);
var arrowSizeProperties = (_b = {},
    _b["small" /* Small */] = {
        width: '12px',
        height: '12px',
        viewbox: '0 0 32 32',
    },
    _b["medium" /* Medium */] = {
        width: '16px',
        height: '16px',
        viewbox: '0 0 32 32',
    },
    _b["large" /* Large */] = {
        width: '18px',
        height: '18px',
        viewbox: '0 0 32 32',
    },
    _b);
exports.Arrow = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? "left" /* Left */ : _b, _c = _a.size, size = _c === void 0 ? "small" /* Small */ : _c, _d = _a.color, color = _d === void 0 ? "default" /* Default */ : _d;
    var arrowClassName = classnames_1.default('ty-arrow', color);
    var directionProps = arrowDirectionProperties[direction || "left" /* Left */];
    var sizeProps = arrowSizeProperties[size || "small" /* Small */];
    return (React.createElement("svg", { className: arrowClassName, viewBox: sizeProps.viewbox, width: sizeProps.width, height: sizeProps.height, "aria-hidden": "true" },
        React.createElement("path", { d: directionProps.path })));
};
